import React from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import { CheckButton, CheckButtonContainer } from '../../config/designSystem/styledComponents';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { ParagraphSRegular } from '../../config/designSystem/typography';
import {  TouchableOpacity, View } from 'react-native';
import { concatPath } from '../../utils/links/concatPath';
import { publicKey, settingStackKey, staticPageKey } from '../../constants/routeKeys';
import { router } from 'expo-router';
import { useStores } from '../../hooks/useStores';


interface TermsAndConditionsProps {
  accepted: boolean,
  setAccepted: (accepted: boolean) => void,
}

export const TermsAndConditions = ({ accepted, setAccepted }: TermsAndConditionsProps) => {
  const rootStore = useStores();

  const goToStaticPage =  (name : string) => {
    router.navigate({
      pathname: concatPath([publicKey,settingStackKey, staticPageKey],2 ) as string,
      params : {
        name
      }
    });
  };


  const labels = rootStore?.language?.translate?.MOBILE?.REGISTER;

  return (
    <View style={{ flexDirection: 'row', margin: 20, justifyContent:'center' , alignItems:'center'}} >
      <CheckButton
        onPress={() => {

          setAccepted(!accepted);
        }}
      >
        <CheckButtonContainer
          style={{
          }}

        >
          {/* In-house checkbox (was react-native-paper's Checkbox.Android, the
              library's last usage). Same 18x18 rounded square + brand check. */}
          <View
            style={{
              width: 20,
              height: 20,
              margin: 8,
              borderRadius: 3,
              borderWidth: 2,
              borderColor: accepted ? COLORS.brand[500] : COLORS.content.secondary,
              backgroundColor: accepted ? COLORS.brand[500] : 'transparent',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            accessibilityRole="checkbox"
            accessibilityState={{ checked: accepted }}
          >
            {accepted && <MaterialCommunityIcons name="check-bold" size={14} color="#fff" />}
          </View>

        </CheckButtonContainer>
      </CheckButton>
      <View
        style={{
          flex: 1,
          flexWrap: 'wrap',
          flexDirection: 'row',
          marginLeft: 10,

        }}>
        <ParagraphSRegular>
          {labels.AGREE_WITH
            ? labels.AGREE_WITH
            : 'I agree with the'}{' '}
        </ParagraphSRegular>
        <TouchableOpacity onPress={() => {
          goToStaticPage('terms-and-conditions');


        }}>

          <ParagraphSRegular color={COLORS.brand[500]} >
            {labels.TERMS_CONDITIONS
              ? labels.TERMS_CONDITIONS
              : 'terms and conditions'}
          </ParagraphSRegular>
        </TouchableOpacity>
        <ParagraphSRegular>
          {' '}{labels.AND
            ? labels.AND
            : 'and'}{' '}
        </ParagraphSRegular>

        <TouchableOpacity onPress={() => {
          goToStaticPage('data-policy');

          // Linking.openURL('https://lmgtfy.com/?q=terms+and+conditions&s=g');
        }}>
          <ParagraphSRegular color={COLORS.brand[500]} >
            {labels.DATA_POLICY
              ? labels.DATA_POLICY
              : 'Data Policy'}
          </ParagraphSRegular>
        </TouchableOpacity>



      </View>
    </View>);


};
